import PlantMonitoringDashboard from './components/PlantMonitoringDashboard';
import React from "react";

function App() {
  return (
    <div className="App">
      <PlantMonitoringDashboard />
    </div>
  );
}

export default App;